import { createApp } from 'vue'
import store from 'store'

import ProductTileGrid from './ProductTileGrid.vue'

const el = '.nti-component--product-tile-grid'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const app = createApp(ProductTileGrid)
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}